export default "__VITE_ASSET__BVIk92qR__"